// extracted by mini-css-extract-plugin
export default {"customerProject":"ActiveCustomerProject-module__customerProject--e67e5"};